import { create } from "zustand";
import { StorageItems } from "../utils/storageItems";

type LanguageType = {
  [key: string]: string;
};

interface LanguageStore {
  language: LanguageType;
  setLanguage: (newLanguage: LanguageType) => void;
}

const getDefaultLanguage = (): LanguageType => {
  const savedLanguageKey =
    localStorage.getItem(StorageItems.APPLANGUAGE) || "English"; // Default to English
  return savedLanguageKey === "Albania"
    ? require("../languages/sq-al.json")
    : require("../languages/en-us.json");
};

export const useLanguageStore = create<LanguageStore>((set) => ({
  language: getDefaultLanguage(),
  setLanguage: (newLanguage: LanguageType) => {
    // Update state
    set({ language: newLanguage });
  },
}));
